import React from "react";
import styled from "styled-components";

const Modal = () => {
  return <StyledModal>Model contents here</StyledModal>;
};

const StyledModal = styled.div`
  padding: 16px 0;
`;

export default Modal;
